{
  "welcome": "Selamat datang ke",
  "instructions": "Ketik di bawah untuk memulakan proses daftar masuk anda.",
  "startCheckIn": "Mula daftar masuk",
  "missingWarehouseTitle": "Gudang Tiada",
  "missingWarehouseMessage": "Pautan tidak sah, ia mesti mengandungi ID Gudang",
  "recaptchaAttribution": "Laman ini dilindungi oleh reCAPTCHA dan {privacyPolicy} serta {termsOfService} Google terpakai.",
  "recaptchaPrivacyPolicy": "Dasar Privasi",
  "recaptchaTermsOfService": "Terma Perkhidmatan",
  "lookupTitle": "Tambah Nombor Rujukan atau Nombor Pengesahan untuk mencari temu janji anda",
  "referenceNumberLabel": "Nombor rujukan atau Nombor pengesahan",
  "referenceNotFoundError": "Nombor rujukan atau pengesahan tidak sepadan dengan mana-mana temu janji yang sah.",
  "checkIn": "Daftar masuk",
  "loadTypeLabel": "Jenis muatan",
  "directionLabel": "Arah",
  "operationLabel": "Operasi",
  "dockLabel": "Dok",
  "orDivider": "atau",
  "noReferenceTitle": "Saya tiada nombor pengesahan",
  "noReferenceDescription": "Teruskan tanpa temu janji menggunakan proses daftar masuk standard.",
  "checkInWithoutAppointment": "Daftar masuk tanpa temu janji",
  "readyToCheckInTitle": "Sedia untuk daftar masuk?",
  "readyToCheckInDescription": "Ketik di bawah untuk bermula. Anda akan memasukkan butiran anda pada skrin seterusnya.",
  "referenceRequiredHint": "Nombor rujukan diperlukan untuk daftar masuk di lokasi ini.",
  "haveAppointment": "Saya ada temu janji",
  "direction": {
    "inbound": "Masuk",
    "outbound": "Keluar",
    "inOut": "Masuk & Keluar",
    "load": "Muat",
    "unload": "Punggah"
  },
  "operation": {
    "live": "Langsung",
    "drop": "Tinggal",
    "other": "Lain-lain"
  }
}
